.separator {
    color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-3));
    margin-inline: rem(8px);
}
